export const contactConfig = {
  email: "info@skillstem.in",
  support: "support@skillstem.in",
  grievance: "grievance@skillstem.in",
  phone: "+91 7075383069",
  whatsapp: "https://wa.me/917075383069",
  officeHours: "Mon–Sat, 10:00–18:00 IST",
  address: {
    line: "Almond Creek Apt, Vijaya Nagar Colony, Hyderabad, Telangana 500008, India",
    mapsUrl:
      "https://www.google.com/maps/search/Almond+Creek+Apartment+Vijaya+Nagar+Colony+Hyderabad+Telangana+500008+India",
    llpin: "ACP-6537",
  },
  dpiitRecognition: "DIPP245767",
  dpiitCertificateUrl: "/documents/DPIIT-DIPP245767.pdf",
  msmeRegistration: "UDYAM-TS-02-0255219",
  msmeCertificateUrl: "/documents/UDYAM-TS-02-0255219.pdf",
  social: {
    linkedin: "https://linkedin.com/company/skillstem",
    twitter: "https://twitter.com/skillstem",
    facebook: "https://facebook.com/skillstem",
    youtube: "https://youtube.com/skillstem",
  },
  ecosystem: [
    {
      name: "SkillSTEM Academy",
      url: "https://skillstem.in",
      description: "Parent organisation",
    },
    {
      name: "Infrastructure & PPP",
      url: "https://infrastructure.skillstem.in",
      description: "Infra & PPP training vertical",
    },
    {
      name: "Life Sciences",
      url: "https://lifesciences.skillstem.in",
      description: "Biotech & life sciences vertical",
    },
    {
      name: "We-Help.in",
      url: "https://we-help.in",
      description: "Free education & employability initiative",
    },
  ],
} as const;

export type ContactConfig = typeof contactConfig;